import { render } from "./contentCategoryOverviewItemSkeletonCard.vue?vue&type=template&id=f37a1792&ts=true"
import script from "./contentCategoryOverviewItemSkeletonCard.vue?vue&type=script&lang=ts"
export * from "./contentCategoryOverviewItemSkeletonCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__